import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Browser Back dismisses a view; cancelling a dirty editor restores the same entry. */
export function useViewHistory(id: string | undefined, close: () => void, mayLeave: () => boolean = () => true) {
  const location = useLocation(); const navigate = useNavigate(); const latest = useRef({ close, mayLeave }); latest.current = { close, mayLeave };
  const route = useRef(location); route.current = location;
  useEffect(() => {
    if (!id) return;
    const origin = route.current; const token = crypto.randomUUID(); const state = { ...origin.state, holdthatView: token };
    navigate({ pathname: origin.pathname, search: origin.search, hash: origin.hash }, { state });
    const back = () => {
      if (window.history.state?.usr?.holdthatView === token) return;
      if (latest.current.mayLeave()) latest.current.close();
      else navigate({ pathname: origin.pathname, search: origin.search, hash: origin.hash }, { state });
    };
    window.addEventListener('popstate', back);
    return () => window.removeEventListener('popstate', back);
  }, [id, navigate]);
}
